import { Box, Drawer, IconButton, Modal } from "@mui/material";
import {
	NeutralColor,
	PrimaryColor,
	SecondaryColor,
} from "node-library/dist/colors";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import { CustomIconButton } from "../button";

interface DrawerProp {
	headerText: string;
	headerDescription?: string;
	open: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
	anchor: "right" | "left" | "top" | "bottom" | undefined;
	children: React.ReactNode;
	drawerWidth?: number;
}

function CustomDrawer(props: DrawerProp) {
	const modelStyle = {
		width: props.drawerWidth || 450,
		// bgcolor: "background.paper",

		// borderRadius: "0",
		// boxShadow: 24,
		p: 1,
		"@media (max-width: 600px)": {
			width: "100%", // Set width to 90% for mobile screens
		},
	};
	return (
		<Drawer
			anchor={props.anchor}
			open={props.open}
			sx={{
				"& .MuiDrawer-paper": {
					borderRadius: 0,
				},
				"@media (max-width: 600px)": {
					width: "100%", // Set width to 90% for mobile screens
					"& .MuiDrawer-paper": {
						width: "100%", // Make sure the paper inside the drawer also takes 100% width
					},
				},
			}}
			onClose={() => props.setOpen(false)}
		>
			<div>
				<div className="drawer-header">
					<div className="drawer-header-text-container">
						<CustomIconButton
							onClick={() => props.setOpen(false)}
							icon={
								<ChevronLeftRoundedIcon
									sx={{
										color: "white !important",
									}}
								/>
							}
							size="small"
							id={"drawer-back-button"}
							buttonClassName="drawer-back-button"
							// sx={{
							// 	color: NeutralColor.NEUTRAL_GREY_900,
							// 	width: "32px",
							// 	height: "32px",
							// 	minWidth: "32px",
							// 	minHeight: "32px",
							// 	borderRadius: "50%", // Make the button round
							// 	"&:hover": {
							// 		bgcolor: NeutralColor.NEUTRAL_GREY_900,
							// 		color: "white",
							// 	},
							// }}
							hoverColor={SecondaryColor.SECONDARY_400}
						></CustomIconButton>
						<div
							className="typography-body-01 typography-bold"
							style={{ color: "white" }}
						>
							{props.headerText}
						</div>
					</div>
					{props.headerDescription && (
						<div
							className="typography-caption"
							style={{ color: NeutralColor.NEUTRAL_GREY_100 }}
						>
							{props.headerDescription}
						</div>
					)}
				</div>
				<Box sx={modelStyle}>
					<div className="modal-body">{props.children}</div>
				</Box>
			</div>
		</Drawer>
	);
}

export { CustomDrawer };
